var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2351 7.87084L16.1292 10.7649M13.2351 7.87084L14.8941 6.21183C15.0298 6.0762 15.2138 6 15.4056 6C15.5975 6 15.7815 6.0762 15.9172 6.21183L17.7882 8.08283C17.9238 8.21851 18 8.40251 18 8.59436C18 8.78621 17.9238 8.9702 17.7882 9.10588L16.1292 10.7649L13.2351 7.87084ZM13.2351 7.87084L6.21199 14.894C6.07629 15.0296 6.00004 15.2136 6 15.4055V17.2765C6 17.4684 6.07623 17.6524 6.21191 17.7881C6.3476 17.9238 6.53162 18 6.72351 18H8.59451C8.78638 18 8.97038 17.9237 9.10603 17.788L16.1292 10.7649L13.2351 7.87084Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b6b55b894efdebc31cc7befbae21ae29.svg";
export { ForwardRef as ReactComponent };